import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc controller
     * @name AuctionBidEditCtrl
     * @memberof app
     *
     * @description
     * Edit your active bid or your bidding curve.
     *
     * @author flzemke.btc
     */
    angular.module('app').controller('AuctionBidEditCtrl', AuctionBidEditCtrl);

    function AuctionBidEditCtrl(
        $routeParams,
        $q,
        $location,
        $anchorScroll,
        auctionsOverviewService,
        auctionResource,
        activitiesService
    ) {
        var vm = this;

        vm.MINIMUM_BID_INFO_BLAH =
            auctionsOverviewService.MINIMUM_BID_INFO_BLAH;
        vm.PAGE = auctionsOverviewService.PAGE;
        vm.auctionId = $routeParams.auctionId;
        vm.bidId = $routeParams.bidId;
        /** @type {app.OrderCurvePointDto[]} */ vm.unifiedBids = null;
        vm.auction = {};
        vm.smallAndLargePriceSteps = {};
        vm.tsos = {
            tso0: false,
            tso1: false
        };
        /** @type {Object} */
        vm.config = null;
        vm.scrollToActiveBid = scrollToActiveBid;
        vm.editBid = editBid;
        vm.deleteActiveBid = deleteActiveBid;
        vm.onAnyAmountChange = onAnyAmountChange;
        vm.onUndiscountedChange = onUndiscountedChange;
        vm.permitLongTermBidDeletion = permitLongTermBidDeletion;
        vm.hasPastBids = false;
        vm.uiLoading = true;
        vm.uiLoadingError = false;
        vm.uiLoadingErrorMessage = '';
        vm.uiDeleteActiveBidError = false;
        vm.showCapacities = false;
        vm.orderCurveMinQuantity = {};
        vm.orderCurveMaxQuantity = {};
        vm.undiscounted = false;

        var auctionUnifiedBidsRequest = auctionResource.unifiedBids(
            { auctionId: vm.auctionId },
            function (res) {
                vm.unifiedBids = auctionsOverviewService.findUnifiedBidsById(
                    res,
                    vm.bidId,
                    false
                );
                vm.activeBid =
                    auctionsOverviewService.getActiveBidFromUnifiedBids(
                        vm.unifiedBids.orderCurve
                    );
                vm.undiscounted = !!vm.unifiedBids.undiscounted;
            },
            function (error) {
                vm.uiLoading = false;
                vm.uiLoadingError = true;
                if (
                    error &&
                    error.data &&
                    (error.data.message || error.data.description)
                )
                    vm.uiLoadingErrorMessage =
                        error.data.message || error.data.description;
            }
        );

        var auctionsRequest = auctionResource.get(
            { auctionId: vm.auctionId },
            function (res) {
                vm.auction = res;
                vm.hasPastBids = auctionsOverviewService.hasPastBids(
                    res.windows
                );
                vm.smallAndLargePriceSteps =
                    activitiesService.getSmallAndLargePriceSteps(
                        res.auctionWindow
                    );
                vm.normalizedPeriodType =
                    auctionsOverviewService.getPeriodTypeByValue(
                        vm.auction.periodType
                    ).NORMALIZED;
            },
            function (error) {
                vm.uiLoading = false;
                vm.uiLoadingError = true;
                if (
                    error &&
                    error.data &&
                    (error.data.message || error.data.description)
                )
                    vm.uiLoadingErrorMessage =
                        error.data.message || error.data.description;
            }
        );

        var auctionConfigRequest = auctionResource.config(
            { auctionId: vm.auctionId, orderId: vm.bidId },
            function (res) {
                vm.config = res;
            },
            function (error) {
                vm.uiLoading = false;
                vm.uiLoadingError = true;
                if (
                    error &&
                    error.data &&
                    (error.data.message || error.data.description)
                )
                    vm.uiLoadingErrorMessage =
                        error.data.message || error.data.description;
            }
        );

        $q.all([
            auctionUnifiedBidsRequest.$promise,
            auctionsRequest.$promise,
            auctionConfigRequest.$promise
        ]).then(function () {
            vm.uiLoading = false;
        });

        function editBid() {
            scrollToActiveBid();
        }

        function scrollToActiveBid() {
            var old = $location.hash();
            $location.hash('editActiveBid');
            $anchorScroll();
            //reset to old to keep any additional routing logic from kicking in
            $location.hash(old);
        }

        function deleteActiveBid() {
            auctionResource.deleteBid(
                { id: vm.bidId },
                function () {
                    auctionsOverviewService.bidDeletedSuccessfully = true;
                    if (vm.auction.algorithmType != 'LONG_TERM') {
                        $location.path('/auctions/list').search({
                            slot: vm.auction.slot,
                            phase: vm.auction.phase,
                            periodType: vm.auction.periodType,
                            ['runtime-from']: vm.auction.runtime.start,
                            ['runtime-to']: vm.auction.runtime.end
                        });
                    } else {
                        $location.path('/auctions/list').search({
                            slot: vm.auction.slot,
                            phase: vm.auction.phase,
                            periodType: vm.auction.periodType,
                            ['runtime-from']: moment().toISOString(),
                            ['runtime-to']: moment()
                                .add(20, 'years')
                                .toISOString()
                        });
                    }
                },
                function () {
                    vm.uiDeleteActiveBidError = true;
                }
            );
        }

        /**
         * Reacts upon changes on amount fields in the pkpYourBiddingCurve directive.
         *
         * @param {Object[]} orderCurve
         * @returns {void}
         */
        function onAnyAmountChange(orderCurve) {
            var minAndMaxQuantities =
                auctionsOverviewService.findMinAndMaxQuantities(orderCurve);
            vm.orderCurveMinQuantity = minAndMaxQuantities.minQuantity;
            vm.orderCurveMaxQuantity = minAndMaxQuantities.maxQuantity;
        }

        /**
         * Reacts upon changes of undiscounted checkbox in the pkpYourBiddingCurve directive.
         *
         * @param {Object[]} undiscounted
         * @returns {void}
         */
        function onUndiscountedChange(undiscounted) {
            vm.undiscounted = undiscounted;
        }

        /**
         * @see {@link app.auctionsOverviewService#permitLongTermBidDeletion}
         * @param round
         * @param phase
         * @returns {boolean}
         */
        function permitLongTermBidDeletion(round, phase) {
            return auctionsOverviewService.permitLongTermBidDeletion(
                round,
                phase
            );
        }
    }
})();
